/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function div(params) {
  return params.reduce((a, b) => Number(a) / (Number(b) || 1));
});
